export const TRAFFIC_AFFECTED_VALUES = {
  DEFAULT: 90,
  WARNING: 20,
} as const
